<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-overflow-y-scroll" ref="horizontalScrollableElement">
      <table class="ts-w-full">
        <thead class="ts-w-full">
          <tr class="ts-bg-black">
            <th
              class="ts-px-4 ts-w-4 ts-py-2 ts-border-t ts-border-b ts-uppercase ts-text-center"
              style="background-color: #f8f8f9"
            >
              {{ $t('numberic') }}
            </th>
            <th
              v-for="(col, index) in columns"
              :key="index"
              class="ts-px-4 ts-py-2 ts-border-t ts-border-b ts-uppercase ts-whitespace-no-wrap"
              :class="col.class"
              :style="{
                'background-color': '#f8f8f9',
                'min-width': col.minWidth ? col.minWidth + 'px' : 'auto',
                width: col.width ? col.width + 'px' : 'auto'
              }"
            >
              <div class="ts-flex ts-items-center">
                <p class="ts-mb-0">{{ col.title }}</p>
                <button
                  class="ts-ml-4 ts-px-2 ts-rounded ts-outline-none bg-transparent"
                ></button>
                <button
                  @click.prevent="onClickSearch"
                  v-if="isShowIconSearch && col.slot == 'action'"
                  class="ts-ml-4 ts-bg-blue-600 ts-px-2 ts-rounded ts-outline-none focus:ts-outline-none"
                  style="position: absolute; right: 9px;"
                >
                  <Icon type="ios-search" class="ts-text-white" />
                </button>
              </div>
            </th>
          </tr>
          <tr class="ts-border-b" v-show="isShowSearch">
            <th style="background-color: #f8f8f9"></th>
            <th
              class="ts-px-4 ts-py-2"
              v-for="(col, index) in columns"
              :key="index"
              :style="{
                'background-color': '#f8f8f9',
                'min-width': col.minWidth ? col.minWidth + 'px' : 'auto',
                width: col.width ? col.width + 'px' : 'auto'
              }"
            >
              <input
                ref="searchInput"
                v-model="model[col.keySearch]"
                v-if="col.keySearch"
                :placeholder="col.title"
                type="text"
                class="ts-border ts-rounded ts-outline-none ts-px-2 ts-py-1 ts-w-full"
                @keypress.enter="onClickGo"
              />
              <button
                @click.prevent="onClickGo"
                v-if="isShowIconSearch && col.slot == 'action'"
                class="ts-bg-blue-400 ts-font-bold ts-px-3 ts-py-1 ts-text-white ts-rounded"
              >
                {{ $t('go') }}
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="ts-border-b" v-for="(item, index) in data" :key="index">
            <td class="ts-text-center">{{ index + 1 }}</td>
            <template v-for="(colB, _colIndex) in columns" class="ts-w-full">
              <td class="ts-px-4 " v-if="colB.slot">
                <slot :name="colB.slot" :row="item" :index="index"></slot>
              </td>
              <td class="ts-px-4 ts-py-2 ts-whitespace-no-wrap" v-else>
                {{ item[colB.key] }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </ts-loading-banner>
</template>

<script>
export default {
  name: 'TsTableFilter',
  props: ['columns', 'data', 'loading'],
  data() {
    return {
      isShowSearch: false,
      // isAbsolute: true,
      model: {}
    }
  },
  computed: {
    isShowIconSearch() {
      return this.columns.filter(c => c.keySearch !== undefined).length
    }
  },
  methods: {
    onClickSearch() {
      this.isShowSearch = !this.isShowSearch
      if (this.isShowSearch) {
        const searchColumn = this.columns.filter(s => s.search === true)

        searchColumn.forEach(key => {
          if (key.keySearch) {
            this.model[key.keySearch] = ''
          }
        })
        this.$nextTick(() => this.$refs.searchInput[0].focus())
      }
    },
    onClickGo() {
      this.$emit(
        'search',
        btoa(unescape(encodeURIComponent(JSON.stringify(this.model))))
      )
    }
    // checkHorizontalScrollEnd() {
    //   const horizontalScrollableElement = this.$refs.horizontalScrollableElement
    //   const atEnd = this.isScrolledToEnd(horizontalScrollableElement)

    //   if (atEnd) {
    //     // User has scrolled to the end horizontally
    //     this.isAbsolute = false
    //   } else {
    //     this.isAbsolute = true
    //   }
    // },
    // isScrolledToEnd(element) {
    //   // Check if the element's scrollLeft is close to the scrollWidth
    //   return element.scrollLeft + element.clientWidth >= element.scrollWidth - 1
    // }
  }
}
</script>
